export const MuiListItemText = () => {
    return {
        root: {
            marginTop: '0',
            marginBottom: '0',
        },
    };
};
